/**
 * 全局命令式 Toast 服务
 * 允许在任意位置调用 showToast
 */

export type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastState {
  visible: boolean;
  message: string;
  type: ToastType;
}

type ToastListener = (state: ToastState) => void;

let listener: ToastListener | null = null;

export const registerToastListener = (fn: ToastListener) => {
  listener = fn;
};

export const unregisterToastListener = () => {
  listener = null;
};

export const showToast = (message: string, type: ToastType = 'info') => {
  if (listener) {
    listener({ visible: true, message, type });
  }
};

export const hideToast = () => {
  if (listener) {
    listener({ visible: false, message: '', type: 'info' });
  }
};
